/** Lista de bancos para o campo Banco nos dados financeiros */
export const BANCOS_OPTIONS = [
  { value: "001", label: "001 - Banco do Brasil" },
  { value: "033", label: "033 - Santander" },
  { value: "104", label: "104 - Caixa Econômica" },
  { value: "237", label: "237 - Bradesco" },
  { value: "341", label: "341 - Itaú" },
  { value: "other", label: "Outro" },
];

/** Dados de teste para o botão "Preencher com dados de teste" (super admin only) */
export const MOCK_FORM_PREENCHIMENTO = {
  docTypeCnpj: false,
  documento: "123.456.789-00",
  nome: "João da Silva Santos",
  dataExpiracao: "2027-12-31",
  ativo: true,
  cep: "01310-100",
  logradouro: "Avenida Paulista",
  numero: "1000",
  bairro: "Bela Vista",
  cidade: "São Paulo",
  uf: "SP",
  email: "joao.silva@email.com",
  telefone: "(11) 91234-5678",
  whatsapp: true,
  tipoVinculo: "associado",
  associadoVinculado: "",
  responsavelComercial: "",
  rg: "12.345.678-9",
  estrangeiro: false,
  passaporte: "",
  rne: "",
  socios: [
    { cpf: "111.222.333-44", nome: "Maria Santos", email: "maria@empresa.com", telefone: "(11) 98765-4321", respLegal: true, respFinanceiro: false },
  ],
  respFinanceiroCpf: "123.456.789-00",
  respFinanceiroNome: "João da Silva Santos",
  respFinanceiroEmail: "joao.silva@email.com",
  respFinanceiroTelefone: "(11) 91234-5678",
  banco: "341",
  agencia: "1234",
  conta: "12345-6",
  pix: "joao.silva@email.com",
};
